import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ComponentList, ComponentTypeVM } from '../manage-components/manage-components.model';
import { ManageComponentsService } from '../manage-components/manage-components.service';
import { SetupEquipmentService } from '../setup-equipment/setup-equipment.service';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-setup-equipment-test',
  templateUrl: './setup-equipment-test.component.html',
  styleUrls: ['./setup-equipment-test.component.scss']
})
export class SetupEquipmentTestComponent implements OnInit {

  constructor(private _equipmentService: SetupEquipmentService,
    private route: ActivatedRoute,
    public _componentservice: ManageComponentsService,) { }
  displayedColumns: string[] = ['ComponentId', 'ComponentDescription','ComponentType', 'ComponentMake','EquipModel'];
  componenttypesList : ComponentTypeVM[];  
  dataSource = new MatTableDataSource();

  componentList:ComponentList[];
  progid: string;
 

  private sub: any;

  public ComponentId: string;
  public ComponentDescription: string;
  public ComponentType: string;
  public ComponentMake: string;
  public EquipModel: string;
  public comSubType: number
  public EquipMake: string;
  public partNo: string;
  public componentName:string;
  public smcs_code:number
  public compart_note:string
  public budget_life:number;
  public moduleid:string;
  public make_auto:number;
  public tool_auto :number;
  public addModel:string
  public track_compart_worn_calc_method_name:string;
  public modified_user:string;
  public modified_date_short:string

  ngOnInit() {

   this._componentservice.getComponentType();
  
  

   this.sub = this.route.params.subscribe(params =>{
    this.ComponentId = params['id'];
    if(this.ComponentId)
    {
      this.GetComponentListForGrid();
    }
   
  })
  }



  changeComponentType(value) {
    this.ComponentType = value
  }
  

  GetComponentListForGrid() {
    this._componentservice.GetComponentTableDetail(this.progid, this.ComponentId, this.ComponentDescription, this.ComponentType, this.EquipMake,
      this.ComponentMake, this.EquipModel).subscribe(result => {
      console.log('grid dasata',result)
        this.dataSource.data = result
      
      });

  }


}
